import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import { useState } from 'react';
import TERM_ITEMS_QUERY from './TermItems.query';

export const TermItemType = {
	IDENTIFICATION_DOCUMENT_TYPE: 'identification_document_type',
	QUESTIONNAIRE_SCHEDULE_FREQUENCY: 'questionnaire_schedule_frequency',
};

export default function TermItemText(props: {
	termItemId: string;
	termType: string;
}) {
	const [termItem, setTermItem] = useState(null);

	// @ts-ignore
	useEffectAsync(async () => {
		if (props.termItemId && props.termType) {
			const result = await apiClient.graphql({
				query: TERM_ITEMS_QUERY,
				variables: { termType: props.termType },
			});
			for (const termItemRaw of result?.data?.termItems?.data) {
				if (termItemRaw.id === props.termItemId) {
					setTermItem(termItemRaw);
				}
			}
		}
	});

	return termItem ? termItem.name : '';
}
